import en from '@/messages/en.json'
import enGame from '@/messages/game/en.json'
import enHome from '@/messages/home/en.json'
import enVishingReports from '@/messages/vishingReports/en.json'
import enVishingAuthoring from '@/messages/vishing-authoring/en.json'
import enVishingCampaignManagement from '@/messages/vishing-campaign-management/en.json'
import enVishingContentDeck from '@/messages/vishing-content-deck/en.json'
import enVishingCallStudio from '@/messages/vishing-call-studio/en.json'
import enVishingAdminOps from '@/messages/vishing-admin-ops/en.json'
import enVishingTemplates from '@/messages/vishing-templates/en.json'
import enVishingLive from '@/messages/vishing-live/en.json'
import enVishingInsights from '@/messages/vishing-insights/en.json'
import enVishingArtwork from '@/messages/vishing-artwork/en.json'
import enVishingRecording from '@/messages/vishing-recording/en.json'
import enSmishing from '@/messages/smishing/en.json'
import enDeepfake from '@/messages/deepfake/en.json'
import enDeepfakeCreateWhen from '@/messages/deepfake-create-when/en.json'
import enDeepfakeCreateThen from '@/messages/deepfake-create-then/en.json'
import enDeepfakeCreateMeeting from '@/messages/deepfake-create-meeting/en.json'
import enDeepfakeCreateEmail from '@/messages/deepfake-create-email/en.json'
import enDeepfakeCreatePick from '@/messages/deepfake-create-pick/en.json'
import enDeepfakeCreate from '@/messages/deepfake-create/en.json'
import enLearner from '@/messages/learner/en.json'
import enPortal from '@/messages/portal/en.json'
import enShell from '@/messages/shell/en.json'
import enVcro from '@/messages/vcro/en.json'
import enKnowledge from '@/messages/knowledge/en.json'
import enKnowledgePortal from '@/messages/knowledge-portal/en.json'
import enGuideCommon from '@/messages/guide-common/en.json'
import enGuideSmishing from '@/messages/guide-smishing/en.json'
import enGuideDeepfake from '@/messages/guide-deepfake/en.json'
import enGuideVishing from '@/messages/guide-vishing/en.json'
import enGuideVcro from '@/messages/guide-vcro/en.json'
import enGuideKnowledge from '@/messages/guide-knowledge/en.json'
import enGuideRecipients from '@/messages/guide-recipients/en.json'
import enGuideWorkflows from '@/messages/guide-workflows/en.json'
import enGuidePhishing from '@/messages/guide-phishing/en.json'
import enGuideEr from '@/messages/guide-er/en.json'
import enGuideLms from '@/messages/guide-lms/en.json'
import enGuideJitTraining from '@/messages/guide-jit-training/en.json'
import enGuideAnnouncements from '@/messages/guide-announcements/en.json'
import enGuideContentStudio from '@/messages/guide-content-studio/en.json'
import enGuideSurveys from '@/messages/guide-surveys/en.json'
import enGuidePolicies from '@/messages/guide-policies/en.json'
import enRoles from '@/messages/roles/en.json'
import enEmailGate from '@/messages/email-gate/en.json'
import enContentStudio from '@/messages/content-studio/en.json'
import enPhishingMail from '@/messages/phishing-mail/en.json'
import enEngineering from '@/messages/engineering/en.json'
import enEngineeringInsights from '@/messages/engineering-insights/en.json'
import enTenantBranding from '@/messages/tenant-branding/en.json'
import enAdminLmsPreview from '@/messages/admin-lms-preview/en.json'
import enAdminLmsAccess from '@/messages/admin-lms-access/en.json'
import enAdminContentLibrary from '@/messages/admin-content-library/en.json'
import enAdminContentStudio from '@/messages/admin-content-studio/en.json'
import enAdminAiStudio from '@/messages/admin-ai-studio/en.json'
import enAdminAiStudioRun from '@/messages/admin-ai-studio-run/en.json'
import enAdminAiModels from '@/messages/admin-ai-models/en.json'
import enAdminAiCost from '@/messages/admin-ai-cost/en.json'
import enAdminAssistant from '@/messages/admin-assistant/en.json'
import enAdminBrands from '@/messages/admin-brands/en.json'
import enAdminCompany from '@/messages/admin-company/en.json'
import enGamification from '@/messages/gamification/en.json'
import enEmailCentre from '@/messages/email-centre/en.json'
import enEmailDesign from '@/messages/email-design/en.json'
import enEmailDelivery from '@/messages/email-delivery/en.json'
import enNotificationAiDraft from '@/messages/notification-ai-draft/en.json'
import enEmailEditor from '@/messages/email-editor/en.json'
import enViz from '@/messages/viz/en.json'
import enSurveys from '@/messages/surveys/en.json'
import enSurveysReports from '@/messages/surveys-reports/en.json'
import enSurveysPortal from '@/messages/surveys-portal/en.json'
import enPolicies from '@/messages/policies/en.json'
import enPoliciesPolicy from '@/messages/policies-policy/en.json'
import enPoliciesEditor from '@/messages/policies-editor/en.json'
import enPoliciesPortal from '@/messages/policies-portal/en.json'
import enPoliciesReader from '@/messages/policies-reader/en.json'
import enPoliciesSimulation from '@/messages/policies-simulation/en.json'
import enPoliciesReports from '@/messages/policies-reports/en.json'
import enGamificationAdmin from '@/messages/gamification-admin/en.json'
import enGamificationPackDetail from '@/messages/gamification-pack-detail/en.json'
import enGamificationChallenges from '@/messages/gamification-challenges/en.json'
import enGamificationActivity from '@/messages/gamification-activity/en.json'
import enGamificationPoints from '@/messages/gamification-points/en.json'
import enGamificationStyles from '@/messages/gamification-styles/en.json'
import enAnnouncements from '@/messages/announcements/en.json'
import enLmsReplay from '@/messages/lms-replay/en.json'
import enFreeForm from '@/messages/free-form/en.json'
import enFreeFormBuilder from '@/messages/free-form-builder/en.json'
import enFreeFormInspector from '@/messages/free-form-inspector/en.json'
import enFreeFormFlow from '@/messages/free-form-flow/en.json'
import enContentStudioCreate from '@/messages/content-studio-create/en.json'
import enContentStudioSettings from '@/messages/content-studio-settings/en.json'
import enFreeFormLibrary from '@/messages/free-form-library/en.json'
import enFreeFormStart from '@/messages/free-form-start/en.json'
import enFreeFormProgress from '@/messages/free-form-progress/en.json'
import enIdentitySso from '@/messages/identity-sso/en.json'
import enIdentityScim from '@/messages/identity-scim/en.json'
import enMailboxAccounts from '@/messages/mailbox-accounts/en.json'
import enLmsEnrolRun from '@/messages/lms-enrol-run/en.json'
import enReviewQueue from '@/messages/review-queue/en.json'
import enAnnouncementsLibrary from '@/messages/announcements-library/en.json'
import enFeedbackTickets from '@/messages/feedback-tickets/en.json'
import enDetectionRules from '@/messages/detection-rules/en.json'
import enSuppressionPickers from '@/messages/suppression-pickers/en.json'
import enAuditBulk from '@/messages/audit-bulk/en.json'
import type { Locale, Messages } from './types'

/**
 * Message catalogues: the main file per language plus the namespace files —
 * messages/shell/<locale>.json (sidebar, navigation, data table, header),
 * messages/portal/<locale>.json (employee-facing surfaces),
 * messages/game/<locale>.json (the PhishTrainer game) and
 * messages/learner/<locale>.json (PhishTrainer learner cards, the portal Team
 * tab), messages/home/<locale>.json (the admin home dashboard) and
 * messages/vcro/<locale>.json (vCRO, the human-risk layer),
 * messages/knowledge/<locale>.json (the Knowledge & assistants admin screens,
 * knowledge wave K0) and
 * messages/knowledge-portal/<locale>.json (the employee policy assistant and
 * library, knowledge wave K1) and messages/guide-<module>/<locale>.json (the
 * shared module "Getting started" guides: guide-common plus one per module) and
 * messages/roles/<locale>.json (Settings → Roles and permissions) and
 * messages/deepfake/<locale>.json (Deepfake Simulation: the nav words and one title and
 * description per page, under the top-level key `deepfake`) and messages/guide-deepfake/ (its guide) and
 * messages/email-gate/<locale>.json (Settings → Email Gate) and
 * messages/content-studio/<locale>.json (the Content Studio live deck build) and
 * messages/phishing-mail/<locale>.json (Phishing → Settings → Mail) and
 * messages/tenant-branding/<locale>.json (Settings → Organization: the workspace logo) and
 * messages/audit-bulk/<locale>.json (what the audit screens call a stored action or entity, ticket #1917) and
 * messages/gamification/<locale>.json (Gamification badge systems: the Global badges, the style names) and
 * messages/email-centre/<locale>.json (Settings → Notifications: the email centre) and
 * messages/email-design/<locale>.json (Settings → Notifications: pictures and styles; the Look tab)
 * messages/email-delivery/<locale>.json (Settings → Notifications: the Delivery tab)
 * messages/notification-ai-draft/<locale>.json (the notification editor's AI-drafted languages)
 * messages/email-editor/<locale>.json (Settings → Notifications: the email editor, words and html)
 * messages/gamification-admin/<locale>.json (Gamification admin: Badge Packs list, new pack, settings, the badge e-mail preview, badge events)
 * messages/gamification-pack-detail/<locale>.json (Gamification admin: one badge pack, its badges and levels)
 * messages/gamification-challenges/<locale>.json (Gamification admin: Challenges)
 * messages/gamification-activity/<locale>.json (Gamification admin: Activity Log, Audit Log, Email Log)
 * messages/gamification-points/<locale>.json (Gamification admin: Leaderboard, Set Points)
 * messages/gamification-styles/<locale>.json (Gamification admin: the five predefined badge styles on Badge Packs, a style's page)
 * messages/announcements/<locale>.json (the Announcements dashboard and its no-sender banner)
 * messages/viz/<locale>.json (the chart kit, components/ui/viz) and the Surveys v2 and
 * Policies namespaces — messages/surveys, surveys-reports, surveys-portal, policies (the shared
 * vocabulary, statuses, errors, library, dashboard, settings), policies-policy (the policy page),
 * policies-editor (editor, review, versions, compare, AI), policies-portal (the portal home and
 * tab and the receipt), policies-reader (the portal flow and the PDF renderer) and
 * policies-simulation, each under ONE top-level key of its own (surveys, surveysReports,
 * surveysPortal, policies, policiesPolicy, policiesEditor, policiesPortal, policiesReader,
 * policiesSimulation) and messages/policies-reports/<locale>.json (Policies -> Reports, the report pages and
 * their menu, 17 Oct 2026: top-level key policiesReports; the 2026-10-15 namespace of that name was retired
 * with the old /policies/reports and this one is new)
 * messages/lms-replay/<locale>.json (LMS Live page: the Replay of a course or an assignment)
 * messages/free-form/<locale>.json (Content Studio's Free Form course builder:
 * the shared vocabulary) with messages/free-form-builder/, free-form-inspector/
 * and free-form-flow/ (the builder, the inspector, and the list, brief,
 * blueprint, preview and export pages) and messages/identity-sso/ and identity-scim/ (Recipients ->
 * Integrations: SAML single sign-on and SCIM provisioning, 27 Oct 2026; top-level keys identitySso and identityScim) and
 * messages/mailbox-accounts/ (Settings -> Mail Delivery: Microsoft Accounts and Google Accounts, 29 Oct 2026; top-level key mailboxAccounts) and
 * messages/lms-enrol-run/ (LMS: the enrol drawer and the background tasks tray, 31 Oct 2026; top-level key lmsEnrolRun) and
 * messages/admin-assistant/ (the console assistant: why the providers failed a turn, 2 Nov 2026; top-level key adminAssistant) and
 * messages/admin-brands/ (the admin area's view of every company's own brand, 4 Nov 2026; top-level key adminBrands) and
 * messages/admin-company/ (a company's page: the Activity tab and the Getting set up card, 4 Nov 2026; top-level key adminCompany)
 * — deep-merged into one tree, so a key in a namespace file is looked up
 * like any other. A new namespace is registered here AND in NAMESPACES of
 * lib/i18n/__tests__/catalogue-integrity.guard.spec.ts (the guard fails on an
 * unregistered messages/<dir>).
 *
 * English is bundled (it is the fallback rung for every language). The others
 * are code-split and fetched when chosen.
 */

type Tree = { [key: string]: unknown }

const isTree = (value: unknown): value is Tree =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

function mergeInto(target: Tree, source: unknown): void {
  if (!isTree(source)) return
  for (const [key, value] of Object.entries(source)) {
    if (isTree(value)) {
      // Always a fresh object, so the imported JSON modules are never mutated.
      const child = isTree(target[key]) ? (target[key] as Tree) : {}
      target[key] = child
      mergeInto(child, value)
    } else {
      target[key] = value
    }
  }
}

/** Deep-merge catalogue parts; for the same key, a later part wins. */
export function mergeCatalogues(...parts: unknown[]): Messages {
  const merged: Tree = {}
  for (const part of parts) mergeInto(merged, part)
  return merged as unknown as Messages
}

/** The merged English catalogue: the fallback rung for every language. */
export const ENGLISH_MESSAGES: Messages = mergeCatalogues(en, enShell, enPortal, enGame, enLearner, enHome, enVishingReports, enVishingAuthoring, enVishingCampaignManagement, enVishingContentDeck, enVishingCallStudio, enVishingAdminOps, enVishingTemplates, enVishingLive, enVishingInsights, enVishingArtwork, enVishingRecording, enSmishing, enDeepfake, enDeepfakeCreate, enDeepfakeCreatePick, enDeepfakeCreateEmail, enDeepfakeCreateMeeting, enDeepfakeCreateThen, enDeepfakeCreateWhen, enVcro, enKnowledge, enKnowledgePortal, enGuideCommon, enGuideSmishing, enGuideDeepfake, enGuideVishing, enGuideVcro, enGuideKnowledge, enGuideRecipients, enGuideWorkflows, enGuidePhishing, enGuideEr, enGuideLms, enGuideJitTraining, enGuideAnnouncements, enGuideContentStudio, enGuideSurveys, enGuidePolicies, enRoles, enEmailGate, enContentStudio, enPhishingMail, enEngineering, enEngineeringInsights, enTenantBranding, enAdminLmsPreview, enAdminLmsAccess, enAdminContentLibrary, enAdminContentStudio, enAdminAiStudio, enAdminAiStudioRun, enGamification, enEmailCentre, enEmailDesign, enEmailDelivery, enNotificationAiDraft, enEmailEditor, enGamificationAdmin, enGamificationPackDetail, enGamificationChallenges, enGamificationActivity, enGamificationPoints, enGamificationStyles, enViz, enSurveys, enSurveysReports, enSurveysPortal, enPolicies, enPoliciesPolicy, enPoliciesEditor, enPoliciesPortal, enPoliciesReader, enPoliciesSimulation, enPoliciesReports, enAnnouncements, enLmsReplay, enFreeForm, enFreeFormBuilder, enFreeFormInspector, enFreeFormFlow, enContentStudioCreate, enContentStudioSettings, enFreeFormLibrary, enFreeFormStart, enFreeFormProgress, enIdentitySso, enIdentityScim, enMailboxAccounts, enLmsEnrolRun, enReviewQueue, enAnnouncementsLibrary, enFeedbackTickets, enDetectionRules, enSuppressionPickers, enAuditBulk, enAdminAiModels, enAdminAiCost, enAdminAssistant, enAdminBrands, enAdminCompany)

// A JSON import resolves to its module namespace in the bundler and to the
// interop wrapper under jest; the catalogue is `default` in both.
const unwrap = (mod: unknown): unknown => (isTree(mod) && 'default' in mod ? mod.default : mod)

// Explicit paths (not a template-literal import) so the bundler emits exactly
// these chunks and TypeScript checks that every lazy language has a loader.
const LOADERS: { [L in Exclude<Locale, 'en'>]: () => Promise<unknown[]> } = {
  ar: () =>
    Promise.all([
      import('@/messages/ar.json'),
      import('@/messages/shell/ar.json'),
      import('@/messages/portal/ar.json'),
      import('@/messages/game/ar.json'),
      import('@/messages/learner/ar.json'),
      import('@/messages/home/ar.json'),
      import('@/messages/vishingReports/ar.json'),
      import('@/messages/vishing-authoring/ar.json'),
      import('@/messages/vishing-campaign-management/ar.json'),
      import('@/messages/vishing-content-deck/ar.json'),
      import('@/messages/vishing-call-studio/ar.json'),
      import('@/messages/vishing-admin-ops/ar.json'),
      import('@/messages/vishing-templates/ar.json'),
      import('@/messages/vishing-live/ar.json'),
      import('@/messages/vishing-insights/ar.json'),
      import('@/messages/vishing-artwork/ar.json'),
      import('@/messages/vishing-recording/ar.json'),
      import('@/messages/smishing/ar.json'),
      import('@/messages/deepfake/ar.json'),
      import('@/messages/deepfake-create-when/ar.json'),
      import('@/messages/deepfake-create-then/ar.json'),
      import('@/messages/deepfake-create-meeting/ar.json'),
      import('@/messages/deepfake-create-email/ar.json'),
      import('@/messages/deepfake-create-pick/ar.json'),
      import('@/messages/deepfake-create/ar.json'),
      import('@/messages/vcro/ar.json'),
      import('@/messages/knowledge/ar.json'),
      import('@/messages/knowledge-portal/ar.json'),
      import('@/messages/guide-common/ar.json'),
      import('@/messages/guide-smishing/ar.json'),
      import('@/messages/guide-deepfake/ar.json'),
      import('@/messages/guide-vishing/ar.json'),
      import('@/messages/guide-vcro/ar.json'),
      import('@/messages/guide-knowledge/ar.json'),
      import('@/messages/guide-recipients/ar.json'),
      import('@/messages/guide-workflows/ar.json'),
      import('@/messages/guide-phishing/ar.json'),
      import('@/messages/guide-er/ar.json'),
      import('@/messages/guide-lms/ar.json'),
      import('@/messages/guide-jit-training/ar.json'),
      import('@/messages/guide-announcements/ar.json'),
      import('@/messages/guide-content-studio/ar.json'),
      import('@/messages/guide-surveys/ar.json'),
      import('@/messages/guide-policies/ar.json'),
      import('@/messages/roles/ar.json'),
      import('@/messages/email-gate/ar.json'),
      import('@/messages/content-studio/ar.json'),
      import('@/messages/phishing-mail/ar.json'),
      import('@/messages/engineering/ar.json'),
      import('@/messages/engineering-insights/ar.json'),
      import('@/messages/tenant-branding/ar.json'),
      import('@/messages/admin-lms-preview/ar.json'),
      import('@/messages/admin-lms-access/ar.json'),
      import('@/messages/admin-content-library/ar.json'),
      import('@/messages/admin-content-studio/ar.json'),
      import('@/messages/admin-ai-studio/ar.json'),
      import('@/messages/admin-ai-studio-run/ar.json'),
      import('@/messages/gamification/ar.json'),
      import('@/messages/email-centre/ar.json'),
      import('@/messages/email-design/ar.json'),
      import('@/messages/email-delivery/ar.json'),
      import('@/messages/notification-ai-draft/ar.json'),
      import('@/messages/email-editor/ar.json'),
      import('@/messages/viz/ar.json'),
      import('@/messages/surveys/ar.json'),
      import('@/messages/surveys-reports/ar.json'),
      import('@/messages/surveys-portal/ar.json'),
      import('@/messages/policies/ar.json'),
      import('@/messages/policies-policy/ar.json'),
      import('@/messages/policies-editor/ar.json'),
      import('@/messages/policies-portal/ar.json'),
      import('@/messages/policies-reader/ar.json'),
      import('@/messages/policies-simulation/ar.json'),
      import('@/messages/policies-reports/ar.json'),
      import('@/messages/gamification-admin/ar.json'),
      import('@/messages/gamification-pack-detail/ar.json'),
      import('@/messages/gamification-challenges/ar.json'),
      import('@/messages/gamification-activity/ar.json'),
      import('@/messages/gamification-points/ar.json'),
      import('@/messages/gamification-styles/ar.json'),
      import('@/messages/announcements/ar.json'),
      import('@/messages/lms-replay/ar.json'),
      import('@/messages/free-form/ar.json'),
      import('@/messages/free-form-builder/ar.json'),
      import('@/messages/free-form-inspector/ar.json'),
      import('@/messages/free-form-flow/ar.json'),
      import('@/messages/content-studio-create/ar.json'),
      import('@/messages/content-studio-settings/ar.json'),
      import('@/messages/free-form-library/ar.json'),
      import('@/messages/free-form-start/ar.json'),
      import('@/messages/free-form-progress/ar.json'),
      import('@/messages/identity-sso/ar.json'),
      import('@/messages/identity-scim/ar.json'),
      import('@/messages/mailbox-accounts/ar.json'),
      import('@/messages/lms-enrol-run/ar.json'),
      import('@/messages/review-queue/ar.json'),
      import('@/messages/announcements-library/ar.json'),
      import('@/messages/feedback-tickets/ar.json'),
      import('@/messages/detection-rules/ar.json'),
      import('@/messages/suppression-pickers/ar.json'),
      import('@/messages/audit-bulk/ar.json'),
      import('@/messages/admin-ai-models/ar.json'),
      import('@/messages/admin-ai-cost/ar.json'),
      import('@/messages/admin-assistant/ar.json'),
      import('@/messages/admin-brands/ar.json'),
      import('@/messages/admin-company/ar.json'),
    ]),
  fr: () =>
    Promise.all([
      import('@/messages/fr.json'),
      import('@/messages/shell/fr.json'),
      import('@/messages/portal/fr.json'),
      import('@/messages/game/fr.json'),
      import('@/messages/learner/fr.json'),
      import('@/messages/home/fr.json'),
      import('@/messages/vishingReports/fr.json'),
      import('@/messages/vishing-authoring/fr.json'),
      import('@/messages/vishing-campaign-management/fr.json'),
      import('@/messages/vishing-content-deck/fr.json'),
      import('@/messages/vishing-call-studio/fr.json'),
      import('@/messages/vishing-admin-ops/fr.json'),
      import('@/messages/vishing-templates/fr.json'),
      import('@/messages/vishing-live/fr.json'),
      import('@/messages/vishing-insights/fr.json'),
      import('@/messages/vishing-artwork/fr.json'),
      import('@/messages/vishing-recording/fr.json'),
      import('@/messages/smishing/fr.json'),
      import('@/messages/deepfake/fr.json'),
      import('@/messages/deepfake-create-when/fr.json'),
      import('@/messages/deepfake-create-then/fr.json'),
      import('@/messages/deepfake-create-meeting/fr.json'),
      import('@/messages/deepfake-create-email/fr.json'),
      import('@/messages/deepfake-create-pick/fr.json'),
      import('@/messages/deepfake-create/fr.json'),
      import('@/messages/vcro/fr.json'),
      import('@/messages/knowledge/fr.json'),
      import('@/messages/knowledge-portal/fr.json'),
      import('@/messages/guide-common/fr.json'),
      import('@/messages/guide-smishing/fr.json'),
      import('@/messages/guide-deepfake/fr.json'),
      import('@/messages/guide-vishing/fr.json'),
      import('@/messages/guide-vcro/fr.json'),
      import('@/messages/guide-knowledge/fr.json'),
      import('@/messages/guide-recipients/fr.json'),
      import('@/messages/guide-workflows/fr.json'),
      import('@/messages/guide-phishing/fr.json'),
      import('@/messages/guide-er/fr.json'),
      import('@/messages/guide-lms/fr.json'),
      import('@/messages/guide-jit-training/fr.json'),
      import('@/messages/guide-announcements/fr.json'),
      import('@/messages/guide-content-studio/fr.json'),
      import('@/messages/guide-surveys/fr.json'),
      import('@/messages/guide-policies/fr.json'),
      import('@/messages/roles/fr.json'),
      import('@/messages/email-gate/fr.json'),
      import('@/messages/content-studio/fr.json'),
      import('@/messages/phishing-mail/fr.json'),
      import('@/messages/engineering/fr.json'),
      import('@/messages/engineering-insights/fr.json'),
      import('@/messages/tenant-branding/fr.json'),
      import('@/messages/admin-lms-preview/fr.json'),
      import('@/messages/admin-lms-access/fr.json'),
      import('@/messages/admin-content-library/fr.json'),
      import('@/messages/admin-content-studio/fr.json'),
      import('@/messages/admin-ai-studio/fr.json'),
      import('@/messages/admin-ai-studio-run/fr.json'),
      import('@/messages/gamification/fr.json'),
      import('@/messages/email-centre/fr.json'),
      import('@/messages/email-design/fr.json'),
      import('@/messages/email-delivery/fr.json'),
      import('@/messages/notification-ai-draft/fr.json'),
      import('@/messages/email-editor/fr.json'),
      import('@/messages/viz/fr.json'),
      import('@/messages/surveys/fr.json'),
      import('@/messages/surveys-reports/fr.json'),
      import('@/messages/surveys-portal/fr.json'),
      import('@/messages/policies/fr.json'),
      import('@/messages/policies-policy/fr.json'),
      import('@/messages/policies-editor/fr.json'),
      import('@/messages/policies-portal/fr.json'),
      import('@/messages/policies-reader/fr.json'),
      import('@/messages/policies-simulation/fr.json'),
      import('@/messages/policies-reports/fr.json'),
      import('@/messages/gamification-admin/fr.json'),
      import('@/messages/gamification-pack-detail/fr.json'),
      import('@/messages/gamification-challenges/fr.json'),
      import('@/messages/gamification-activity/fr.json'),
      import('@/messages/gamification-points/fr.json'),
      import('@/messages/gamification-styles/fr.json'),
      import('@/messages/announcements/fr.json'),
      import('@/messages/lms-replay/fr.json'),
      import('@/messages/free-form/fr.json'),
      import('@/messages/free-form-builder/fr.json'),
      import('@/messages/free-form-inspector/fr.json'),
      import('@/messages/free-form-flow/fr.json'),
      import('@/messages/content-studio-create/fr.json'),
      import('@/messages/content-studio-settings/fr.json'),
      import('@/messages/free-form-library/fr.json'),
      import('@/messages/free-form-start/fr.json'),
      import('@/messages/free-form-progress/fr.json'),
      import('@/messages/identity-sso/fr.json'),
      import('@/messages/identity-scim/fr.json'),
      import('@/messages/mailbox-accounts/fr.json'),
      import('@/messages/lms-enrol-run/fr.json'),
      import('@/messages/review-queue/fr.json'),
      import('@/messages/announcements-library/fr.json'),
      import('@/messages/feedback-tickets/fr.json'),
      import('@/messages/detection-rules/fr.json'),
      import('@/messages/suppression-pickers/fr.json'),
      import('@/messages/audit-bulk/fr.json'),
      import('@/messages/admin-ai-models/fr.json'),
      import('@/messages/admin-ai-cost/fr.json'),
      import('@/messages/admin-assistant/fr.json'),
      import('@/messages/admin-brands/fr.json'),
      import('@/messages/admin-company/fr.json'),
    ]),
  hi: () =>
    Promise.all([
      import('@/messages/hi.json'),
      import('@/messages/shell/hi.json'),
      import('@/messages/portal/hi.json'),
      import('@/messages/game/hi.json'),
      import('@/messages/learner/hi.json'),
      import('@/messages/home/hi.json'),
      import('@/messages/vishingReports/hi.json'),
      import('@/messages/vishing-authoring/hi.json'),
      import('@/messages/vishing-campaign-management/hi.json'),
      import('@/messages/vishing-content-deck/hi.json'),
      import('@/messages/vishing-call-studio/hi.json'),
      import('@/messages/vishing-admin-ops/hi.json'),
      import('@/messages/vishing-templates/hi.json'),
      import('@/messages/vishing-live/hi.json'),
      import('@/messages/vishing-insights/hi.json'),
      import('@/messages/vishing-artwork/hi.json'),
      import('@/messages/vishing-recording/hi.json'),
      import('@/messages/smishing/hi.json'),
      import('@/messages/deepfake/hi.json'),
      import('@/messages/deepfake-create-when/hi.json'),
      import('@/messages/deepfake-create-then/hi.json'),
      import('@/messages/deepfake-create-meeting/hi.json'),
      import('@/messages/deepfake-create-email/hi.json'),
      import('@/messages/deepfake-create-pick/hi.json'),
      import('@/messages/deepfake-create/hi.json'),
      import('@/messages/vcro/hi.json'),
      import('@/messages/knowledge/hi.json'),
      import('@/messages/knowledge-portal/hi.json'),
      import('@/messages/guide-common/hi.json'),
      import('@/messages/guide-smishing/hi.json'),
      import('@/messages/guide-deepfake/hi.json'),
      import('@/messages/guide-vishing/hi.json'),
      import('@/messages/guide-vcro/hi.json'),
      import('@/messages/guide-knowledge/hi.json'),
      import('@/messages/guide-recipients/hi.json'),
      import('@/messages/guide-workflows/hi.json'),
      import('@/messages/guide-phishing/hi.json'),
      import('@/messages/guide-er/hi.json'),
      import('@/messages/guide-lms/hi.json'),
      import('@/messages/guide-jit-training/hi.json'),
      import('@/messages/guide-announcements/hi.json'),
      import('@/messages/guide-content-studio/hi.json'),
      import('@/messages/guide-surveys/hi.json'),
      import('@/messages/guide-policies/hi.json'),
      import('@/messages/roles/hi.json'),
      import('@/messages/email-gate/hi.json'),
      import('@/messages/content-studio/hi.json'),
      import('@/messages/phishing-mail/hi.json'),
      import('@/messages/engineering/hi.json'),
      import('@/messages/engineering-insights/hi.json'),
      import('@/messages/tenant-branding/hi.json'),
      import('@/messages/admin-lms-preview/hi.json'),
      import('@/messages/admin-lms-access/hi.json'),
      import('@/messages/admin-content-library/hi.json'),
      import('@/messages/admin-content-studio/hi.json'),
      import('@/messages/admin-ai-studio/hi.json'),
      import('@/messages/admin-ai-studio-run/hi.json'),
      import('@/messages/gamification/hi.json'),
      import('@/messages/email-centre/hi.json'),
      import('@/messages/email-design/hi.json'),
      import('@/messages/email-delivery/hi.json'),
      import('@/messages/notification-ai-draft/hi.json'),
      import('@/messages/email-editor/hi.json'),
      import('@/messages/viz/hi.json'),
      import('@/messages/surveys/hi.json'),
      import('@/messages/surveys-reports/hi.json'),
      import('@/messages/surveys-portal/hi.json'),
      import('@/messages/policies/hi.json'),
      import('@/messages/policies-policy/hi.json'),
      import('@/messages/policies-editor/hi.json'),
      import('@/messages/policies-portal/hi.json'),
      import('@/messages/policies-reader/hi.json'),
      import('@/messages/policies-simulation/hi.json'),
      import('@/messages/policies-reports/hi.json'),
      import('@/messages/gamification-admin/hi.json'),
      import('@/messages/gamification-pack-detail/hi.json'),
      import('@/messages/gamification-challenges/hi.json'),
      import('@/messages/gamification-activity/hi.json'),
      import('@/messages/gamification-points/hi.json'),
      import('@/messages/gamification-styles/hi.json'),
      import('@/messages/announcements/hi.json'),
      import('@/messages/lms-replay/hi.json'),
      import('@/messages/free-form/hi.json'),
      import('@/messages/free-form-builder/hi.json'),
      import('@/messages/free-form-inspector/hi.json'),
      import('@/messages/free-form-flow/hi.json'),
      import('@/messages/content-studio-create/hi.json'),
      import('@/messages/content-studio-settings/hi.json'),
      import('@/messages/free-form-library/hi.json'),
      import('@/messages/free-form-start/hi.json'),
      import('@/messages/free-form-progress/hi.json'),
      import('@/messages/identity-sso/hi.json'),
      import('@/messages/identity-scim/hi.json'),
      import('@/messages/mailbox-accounts/hi.json'),
      import('@/messages/lms-enrol-run/hi.json'),
      import('@/messages/review-queue/hi.json'),
      import('@/messages/announcements-library/hi.json'),
      import('@/messages/feedback-tickets/hi.json'),
      import('@/messages/detection-rules/hi.json'),
      import('@/messages/suppression-pickers/hi.json'),
      import('@/messages/audit-bulk/hi.json'),
      import('@/messages/admin-ai-models/hi.json'),
      import('@/messages/admin-ai-cost/hi.json'),
      import('@/messages/admin-assistant/hi.json'),
      import('@/messages/admin-brands/hi.json'),
      import('@/messages/admin-company/hi.json'),
    ]),
}

/** The languages fetched on demand (every supported language but English). */
export const LAZY_LOCALES = Object.keys(LOADERS) as Array<Exclude<Locale, 'en'>>

const loaded = new Map<Locale, Promise<Messages>>()

/**
 * The merged catalogue for `locale`, fetched once. A failed fetch (offline, a
 * chunk that changed under a deploy) is forgotten so the next attempt retries.
 */
export function loadMessages(locale: Locale): Promise<Messages> {
  if (locale === 'en') return Promise.resolve(ENGLISH_MESSAGES)
  let pending = loaded.get(locale)
  if (!pending) {
    const loader = LOADERS[locale]
    if (!loader) return Promise.reject(new Error(`No catalogue for locale "${locale}"`))
    pending = loader()
      .then((parts) => mergeCatalogues(...parts.map(unwrap)))
      .catch((error: unknown) => {
        loaded.delete(locale)
        throw error
      })
    loaded.set(locale, pending)
  }
  return pending
}
